// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Lbpat","overflowing":"ReadFullNote_overflowing__3Lp1u"};